const write = () => import(/* webpackChunkName: "mail" */ '@/page/mail/write')
const mail = () => import(/* webpackChunkName: "mail" */ '@/page/mail/mail')
const mailDetail = () => import(/* webpackChunkName: "mail" */ '@/page/mail/detail')
const maillist = () => import(/* webpackChunkName: "mail" */ '@/page/mail/list')

const getMailArray = () => {
    let mailStates = ['unread', 'recv', 'draft', 'deleted', 'send', 'spam', 'gtasks', 'star', 'important', 'search']
    let mailArray = []
    mailStates.forEach(element => {
        mailArray.push({
            path: element,
            name: element,
            component: maillist,
            children: [{
                path: `col`,
                name: `${element}col`,
                component: mailDetail
            }] 
        })
        mailArray.push({
            path: `${element}/:id`,
            name: `${element}Detail`,
            component: mailDetail
        })
    })
    mailArray.push({
        path: '/mail/detail/:id',
        name: 'detail',
        component: mailDetail
    })
    mailArray.push({
        path: '/mail/other/:folderId',
        name: 'other',
        component: maillist,
        children: [{
            path: `col`,
            name: `othercol`,
            component: mailDetail
        }]
    })
    mailArray.push({
        path: '/mail/other/:folderId/:id',
        name: 'otherDetail',
        component: mailDetail
    })
    mailArray.push({
        path: '/mail/multi/:folderId',
        name: 'multi',
        component: maillist,
        children: [{
            path: `col`,
            name: `multicol`,
            component: mailDetail
        }]
    })
    mailArray.push({
        path: '/mail/multi/:folderId/:id',
        name: 'multiDetail',
        component: mailDetail
    })
    mailArray.push({
        path: '/mail*',
        redirect: 'recv'
    })
    return mailArray
}

const mailRouter = [{
    path: '/mail/write',
    name: 'write',
    component: write
}, {
    path: 'mail',
    name: 'mail',
    component: mail,
    children: getMailArray()
}]

export default mailRouter



// WEBPACK FOOTER //
// ./src/router/mail.js